(ns app.front.view.admin.commands.delete-ag-entity
  (:require [app.front.ui :as ui]
            [app.front.util :as futil]
            [app.front.view.group.admin.common :as acommon]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.event :refer [>evt]]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))

(rf/reg-event-fx ::delete
  (fn [_ [_ entity-id group-id]]
    {:comm/command {:command :admin/delete-ag-entity
                    :method  :post
                    :data    {:entity-id entity-id
                              :group-id  group-id}
                    :notify  {:success "Authority group entity deleted"}}}))

(defn view [match]
  [acommon/admin-page-v2 (util/mmap {:title "Delete authority group entity"} match)
   [:section
    [:div
     [ui/help "Delete an authority group entity (type :entity.type/group) by its entity ID.
               This will also delete all children via :entity/parent, entities linked via :domain/authority-group, :group.config/group, :party-role/authority-group, :attachment-type/authority-group, :visit-result-detail-label/group, :closure-category/authority-group, related :entity.type/authorization entities, and descendants of those linked entities.
               
               This tool was made to remove legacy Red River Planning District, Planning Department which was created without :group/permit-type-configs in CA Training.
               
               This tool is not available to be used in production."]]]
   (r/with-let [*entity-id    (r/atom nil)
                *group-id     (r/atom "")
                *confirm-open (r/atom false)]
     (let [valid? (and (integer? @*entity-id)
                       (not (str/blank? @*group-id)))]
       [:section
        [:div.p-6
         [ui/number-input {:id          "entity-id"
                           :light       true
                           :value       @*entity-id
                           :required    true
                           :on-change   #(reset! *entity-id (parse-long (futil/tval %)))
                           :placeholder "Entity ID"
                           :label-text  "Entity ID of the group to delete"}]]
        [:div.p-6
         [ui/text-input {:id          "group-id"
                         :light       true
                         :value       @*group-id
                         :required    true
                         :on-change   #(reset! *group-id (futil/tval %))
                         :placeholder "Group ID"
                         :label-text  "Group ID (:group/id) of the group to delete"}]]
        [:div.p-6
         [cc/button {:kind     :danger
                     :disabled (not valid?)
                     :on-click #(reset! *confirm-open true)}
          "Delete entity"]]
        [ui/confirm-modal
         {:open?           @*confirm-open
          :id              "delete-ag-entity"
          :tr              identity
          :modal-title     "Confirm deletion"
          :dangerous?      true
          :on-close        #(reset! *confirm-open false)
          :on-yes-click    (fn []
                             (>evt [::delete @*entity-id @*group-id])
                             (reset! *confirm-open false))
          :yes-button-text "Delete"
          :no-button-text  "Cancel"}
         [:p (str "Are you sure you want to delete authority group entity " @*group-id ", " @*entity-id
                  "? This will also delete all children and related entities.")]]]))])

(def route
  {:name        :view/admin.commands.delete-ag-entity
   :own-layout? true
   :view        view})
